/**
 * Stable per-browser id for the paper trading session. The API keys every simulator ledger by
 * this value, so resetting a session only ever clears this browser's own fills and hedges.
 */

const STORAGE_KEY = 'price-forecast:sim-session';

export const SIM_SESSION_HEADER = 'x-sim-session';
export const SIM_SESSION_PARAM = 'session';

function createSessionId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `s-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

let cachedSessionId = null;

export function getSimSessionId() {
  if (cachedSessionId) return cachedSessionId;
  if (typeof window === 'undefined') return null;

  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      cachedSessionId = stored;
      return cachedSessionId;
    }
    cachedSessionId = createSessionId();
    window.localStorage.setItem(STORAGE_KEY, cachedSessionId);
    return cachedSessionId;
  } catch {
    // Private mode with storage disabled: keep the id in memory for this page view.
    cachedSessionId = cachedSessionId || createSessionId();
    return cachedSessionId;
  }
}

export function resetSimSessionCache() {
  cachedSessionId = null;
}
